(function () {
  document.querySelectorAll('[data-aceites-olive]').forEach(function (root) {
    var track = root.querySelector('[data-aceites-olive-track]');
    var nextBtn = root.querySelector('[data-aceites-olive-next]');
    var prevBtn = root.querySelector('[data-aceites-olive-prev]');
    if (!track) return;

    function scrollAmount() {
      var first = track.querySelector('.aceites-olive-types__item');
      if (!first) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '12') || 12;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prevBtn) prevBtn.hidden = atStart;
      if (nextBtn) nextBtn.hidden = atEnd;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    // Tap-to-reveal overlay en mobile (mismo contenido que el hover de desktop)
    var cards = root.querySelectorAll('.aceites-olive-types__card');
    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (!isMobile()) return;
        if (card.classList.contains('is-active')) return; // segundo tap → permite navegar
        e.preventDefault();
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
      });
    });
    document.addEventListener('click', function (e) {
      if (!isMobile()) return;
      if (e.target.closest('.aceites-olive-types__card')) return;
      cards.forEach(function (c) { c.classList.remove('is-active'); });
    });
  });
})();
